module.exports = __webpack_public_path__ + "img/41.e5ff6c88.webp";